import React from 'react';
import SelectionLivePreview from './SelectionLivePreview';
import C from '../colors';

export default function OrderPreviewPanel({ showImageName, forceLimit, isOnlinePayment, price, photoCount, hasPackage }) {
  return (
    <div style={{ overflow: 'hidden' }}>
      <div style={{ width: 'min(100%, 390px)', margin: '0 auto', padding: '24px 0', position: 'sticky', top: 0 }}>
        <div style={{ marginBottom: 12 }}>
          <div style={{ fontFamily: C.mono, fontSize: 10, letterSpacing: 1.2, textTransform: 'uppercase', color: C.ink3 }}>
            实时客户视角
          </div>
          <div style={{ marginTop: 5, fontFamily: C.sans, fontSize: 12, color: C.ink3 }}>
            点击照片和筛选项，预览当前设置的实际效果
          </div>
        </div>
        <SelectionLivePreview
          showImageName={showImageName}
          forceLimit={forceLimit}
          isOnlinePayment={isOnlinePayment}
          price={price}
          photoCount={photoCount}
          hasPackage={hasPackage}
        />
      </div>
    </div>
  );
}
